export default __webpack_public_path__ + "static/media/SARS-CoV-2.05fa249a.png";